
<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
        this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button  type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
         
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.chargeNo" @keyup.enter.native="queryChange" suffix-icon="el-icon-search" />
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
 
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>

        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
        <el-table-column prop="supplierProductNo"  min-width="180" label="供应商产品编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" min-width="200" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName"  min-width="180" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName"  min-width="180" label="生产厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName"  min-width="180" label="供应商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"  min-width="200"></el-table-column>
        <el-table-column prop="describe" show-overflow-tooltip label="医保码更新说明"  min-width="200"></el-table-column>
      </el-table>
    </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>
 
<script>
import {
  GetMedicalInsuranceUpdateReminds,
  ExportMedicalInsuranceUpdateReminds,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
        exportAction: ExportMedicalInsuranceUpdateReminds,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      // 新增、编辑的数据
      // 多选框数据
      ids: [],
      multipleSelection: [],
      totalNumber: 0,
      // 列表多选
      multiple: true,
      editMode: false,

      filterOptions: [

      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
            {
        name: "医保代码",
        type: "input",
        code: "medicalInsuranceCategoryNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
   
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
   
     
      ],
   
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
      if (selection) {
        this.totalAmount = 0
        this.totalNumber = 0
        selection.forEach(item => {
          this.totalAmount += item.amount
          this.totalNumber += item.number
        })
      }
      this.totalAmount = this.totalAmount.toFixed(3) * 1
    },
    // 获取列表
    getData () {
      GetMedicalInsuranceUpdateReminds(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
   
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
 
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        endDate:'',
        startDate:'',
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;
 
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
 
<style lang="scss" scoped></style>